import Head from "next/head";

import RequirementsContext from "@/context/requirementsContext";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";
import Requerimiento from "@/sections/requerimiento/Requerimiento";

const Requerimientos = () => {
    return (
        <>
            <Head>
                <title>Requerimiento | Grupo Guía</title>
            </Head>
            <Header />
            <RequirementsContext>
                <Requerimiento />
            </RequirementsContext>
            <Footer esGuiaRent={false} />
        </>
    );
};

export default Requerimientos;
